import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import houseImage from '../assets/homePageImage.jpg';

function Home() {
  const navigate = useNavigate();

  const handleSearchClick = () => {
    navigate('/search');
  };

  return (
    <div className="home-section">
      <img src={houseImage} alt="Luxury California Home" className="home-image" />
      <div className="home-overlay">
        <h1 className="home-heading">Explore the best properties in California</h1>
        <button className="home-button" onClick={handleSearchClick}>
          Find your new Home
        </button>
      </div>
    </div>
  );
}

export default Home;
